import LineScale from '@/components/line-scale/line-scale.vue'

export default {
  name: 'LineScaleComplex',
  props: {
    /**
     * Целочисленное пороговое значение
     */
    threshold: {
      type: Number,
      default: 3
    },
    /**
     * Значение в пределах поргового значения,
     * может быть с дробной частью
     */
    value: {
      type: Number,
      default: 0
    },
    
    colorThumb: {
      type: String,
      default: 'grey' // red, yellow, green
    }
  },
  components: {
    LineScale
  },
  methods: {
    getValuePart(partNumber) {
      if (this.value > this.threshold) {
        return 100
      }
      const valueInt = Math.floor(this.value)
      if (partNumber <= valueInt) {
        return 100
      }
      const lastValue = valueInt + 1
      if (partNumber > lastValue) {
        return 0
      }
      return (this.value - valueInt) * 100
    }
  }
}